(function initializeChorelessMobileHeader() {
  const mobileQuery = window.matchMedia('(max-width: 989px)');
  const reducedMotionQuery = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );
  const header = document.querySelector('#header-component');
  const categoryTrack = document.querySelector(
    '.pet-category-nav__inner'
  );

  const markCurrentCategory = () => {
    if (!categoryTrack) return;

    const currentUrl = new URL(window.location.href);
    const currentPath =
      currentUrl.pathname.replace(/\/+$/, '') || '/';
    const categoryLinks = Array.from(
      categoryTrack.querySelectorAll('a[href]')
    );

    let activeLink = null;

    for (const link of categoryLinks) {
      const linkUrl = new URL(link.href, window.location.origin);
      const linkPath =
        linkUrl.pathname.replace(/\/+$/, '') || '/';

      if (linkPath !== currentPath || linkUrl.search === '') {
        continue;
      }

      const queryMatches = Array.from(
        linkUrl.searchParams.entries()
      ).every(
        ([key, value]) =>
          currentUrl.searchParams.get(key) === value
      );

      if (queryMatches) {
        activeLink = link;
        break;
      }
    }

    if (!activeLink && currentUrl.search === '') {
      activeLink = categoryLinks.find((link) => {
        const linkUrl = new URL(link.href, window.location.origin);
        const linkPath =
          linkUrl.pathname.replace(/\/+$/, '') || '/';

        return linkPath === currentPath && linkUrl.search === '';
      });
    }

    categoryLinks.forEach((link) => {
      const isActive = link === activeLink;
      link.classList.toggle('is-active', isActive);

      if (isActive) {
        link.setAttribute('aria-current', 'page');
      } else {
        link.removeAttribute('aria-current');
      }
    });

    if (!activeLink) return;

    window.requestAnimationFrame(() => {
      const targetLeft =
        activeLink.offsetLeft -
        (categoryTrack.clientWidth - activeLink.offsetWidth) / 2;

      categoryTrack.scrollTo({
        left: Math.max(0, targetLeft),
        behavior: 'auto',
      });
    });
  };

  markCurrentCategory();

  if (!header) return;

  let lastScrollY = Math.max(window.scrollY, 0);
  let scrollFrame = null;

  const updateHeaderState = () => {
    scrollFrame = null;

    if (!mobileQuery.matches) {
      header.classList.remove(
        'choreless-header--compact',
        'choreless-header--scrolled'
      );
      lastScrollY = Math.max(window.scrollY, 0);
      return;
    }

    const currentScrollY = Math.max(window.scrollY, 0);
    const movement = currentScrollY - lastScrollY;

    header.classList.toggle(
      'choreless-header--scrolled',
      currentScrollY > 8
    );

    if (currentScrollY <= 16 || movement < -4) {
      header.classList.remove('choreless-header--compact');
    } else if (movement > 4) {
      header.classList.add('choreless-header--compact');
    }

    lastScrollY = currentScrollY;
  };

  const scheduleHeaderUpdate = () => {
    if (scrollFrame !== null) return;
    scrollFrame = window.requestAnimationFrame(updateHeaderState);
  };

  window.addEventListener('scroll', scheduleHeaderUpdate, {
    passive: true,
  });
  mobileQuery.addEventListener('change', updateHeaderState);
  updateHeaderState();

  document.addEventListener(
    'shopify:cart:lines-update',
    (event) => {
      if (event.action !== 'add') return;

      const acknowledgeCart = () => {
        if (!mobileQuery.matches || reducedMotionQuery.matches) {
          return;
        }

        const cartIcon = header.querySelector(
          '.header-actions__cart-icon'
        );

        if (!cartIcon) return;

        cartIcon.classList.remove('choreless-cart--added');
        window.requestAnimationFrame(() => {
          cartIcon.classList.add('choreless-cart--added');
        });

        window.setTimeout(() => {
          cartIcon.classList.remove('choreless-cart--added');
        }, 380);
      };

      if (event.promise) {
        event.promise
          .then(({ detail }) => {
            if (!detail?.didError) acknowledgeCart();
          })
          .catch(() => {
            /*
             * Cart errors are announced by the product form; no visual
             * confirmation should play when an item was not added.
             */
          });
      } else {
        acknowledgeCart();
      }
    }
  );
})();
